<template>
  <div class="empty flex flex_justify-center flex_align-items">
    <i class="el-icon-warning" style="font-size: 50px;color: #999"></i>
    <p>暂无培训课程</p>
  </div>
</template>

<script>
export default {
  name: "Empty"
}
</script>

<style scoped lang="scss">
.empty{
  flex-direction: column;
  color: #9199a1;
  padding-top: 100px;

  p {
    margin-top: 10px;
  }
}
</style>